/* React */
import { useState } from 'react'

/* Material */
import Button from '@mui/material/Button'
import useStyles from './styles'

/* Components */
import Login from './Login'
import Registration from './Registration'

const Ausgeloggt = () => {
  const classes = useStyles()

  const [tab, switchTab] = useState<'login'|'register'>('login')

  return <div className={classes.rootAusgeloggt}>

    <div className={classes.tabsAuswahl}>
      {([
        {name:'login', title:'Login'},
        {name:'register', title:'Registrieren'},
      ] as const).map(option=>
        <Button 
          key={option.name}
          size='large' variant='contained'
          color={tab===option.name ? 'success' : 'secondary'}
          onClick={()=>switchTab(option.name)}
        >
          {option.title}
        </Button>
      )}
    </div>

    {tab==='login' &&
      <Login />
    }

    {tab==='register' &&
      <Registration />
    }
    
  </div>
}

export default Ausgeloggt
